import session from "../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../services/api";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            id: 0,
            expireDate: null,
            restOfTraining: '',
            model: {
                firstName: '',
                lastName: '',
                username: ''
            }
        }
    },
    methods: {
        load:load,
        checkNull:checkNull,
        update:update,
        resetPassword: resetPassword,
        formatDate:formatDate
    },
    beforeMount() {
        if(session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/home');
            return;
        }
        this.load()
    }
}

function load() {
    let _self = this;
    AdminApiService.getDispatcherAdminMe()
        .then((response) => {
            _self.model.username = response.data.username;
            _self.model.firstName = this.checkNull(response.data.firstName);
            _self.model.lastName = this.checkNull(response.data.lastName);

        })
        .catch(error => {
            swal('Greška', error.data.message, 'error')
        })
}

function update() {

    if(this.model.firstName.length === 0 ||
        this.model.lastName.length === 0 ||
        this.model.username.length === 0){
        swal('Greška', 'Molimo vas popunite sva polja.', 'error')
        return;
    }
    let _self = this;
    AdminApiService.updateDispatchersAndAdmin(_self.model)
        .then((response) => {
            swal('Uspešno', 'Uspešno izmenjeni podaci.', 'success')
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function resetPassword() {
    this.$router.push('/reset-password');
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function checkNull(data) {
    if(data == null) return '';
    return data;
}


// WEBPACK FOOTER //
// ./src/components/Profile/ProfileDetails.js